import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { createSettingsFailed, createSettingsSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { CREATED } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* createSettings(action) {
  try {
    const url = `${BACKEND_URL}/resources/settings`;
    const pool = action.payload;
    const response = yield makeRequest(url, pool, action, 'POST', true);
    if (response.status === CREATED) {
      const data = yield getBodyJson(response);
      yield put(createSettingsSuccessful());
      yield call(resolveActionPromise(action, data));
    } else {
      const data = yield getBodyJson(response);
      yield put(createSettingsFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(createSettingsFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
